import { action } from 'mobx'

import AgencyResources from 'Services/AgencyResources'
import BaseStore from 'Stores/base_store/BaseStore'
import { getStoreFor } from 'Stores/StoreInstances'

export const STORE_TYPE = 'JobTypes'

export function getJobTypesStoreFor (param, opts = {}) {
  return getStoreFor(JobTypesStore, STORE_TYPE, param, {
    forceUnique: false,
    preload: opts.preload,
    autoFetch: opts.autoFetch,
    fetchAll: opts.fetchAll,
  })
}

class JobTypesStore extends BaseStore {
  constructor (seedData) {
    const opts = {
      paginate: false,
    }
    super(STORE_TYPE, seedData, opts)
  }

  @action
  _fetchAll () {
    let payload = {
      ...this._filter,
    }
    return AgencyResources.requestResources(payload)
        .then(resources => resources.job_types)
        .catch(console.error)
  }
}

export default JobTypesStore
